<template>
    <div class="coming-soon flex-center">
        <v-container fluid class="home-1 px-0 flex-center">
            <v-container class="content-wrap pt-10 flex-center">
                <v-row>
                    <v-col lg="6" md="6" sm="12" class="flex-center flex-column pr-10">
                        <h1 class="blue-text bold display-3 w-100 text-left">
                            Digitalna platforma <br>
                            za škole
                        </h1>
                        <p class="mt-5 text--secondary w-100 text-left">
                            Koordinacija ministara obrazovanja, znanosti, kulture i športa županija
                            u kojima se nastavni planovi i programi izvode na hrvatskom jeziku u
                            suradnji sa Sveučilištem u Mostaru
                        </p>
                        <v-divider class="home-1-divider mt-3"></v-divider>
                        <div class="flex-left w-100 powered-wrap mb-4 mb-lg-0">
                            <p class="overline text--disabled mr-5 mb-0">POWERED BY</p>
                            <a href="https://sumit.sum.ba" target="_blank" class="mt-7">
                                <sumit></sumit>
                            </a>
                            <a href="https://carnet.hr" target="_blank" class="">
                                <carnet></carnet>
                            </a>
                        </div>
                        <v-divider class="home-1-divider mb-4"></v-divider>
                        <div class="flex-left w-100 powered-wrap">
                            <p class="overline text--disabled mr-5 mb-0">TEHNOLOŠKI PARTNER</p>
                            <a href="https://hteronet.ba" target="_blank">
                                <eronet></eronet>
                            </a>
                        </div>
                    </v-col>
                    <v-col lg="6" md="6" sm="12" class="flex-center">
                        <video controls class="w-100 video mt-5" :poster="require('@/assets/img/poster.png')">
                            <source src="coming-soon.mp4" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </div>
</template>
<script>
import Sumit from '../components/Sumit'
import Eronet from '../components/Eronet'
import Carnet from '../components/Carnet'
import LogoBlue from '../components/LogoBlue'
export default {
    name: "ComingSoon",
    components: {
        LogoBlue,
        Sumit,
        Eronet,
        Carnet
    }
}
</script>
<style lang="scss" scoped>
.coming-soon {
    min-height: 70vh;
    position: relative;
}

.home-1 {
    background-color: #F0F5F7;
    display: flex;
    justify-content: center;
    align-items: center;
}

.home-1-divider {
    width: 100% !important;
}

.powered-wrap {
    p {
        font-size: 10px !important;
        letter-spacing: 2px;
    }
}
.video {
    min-width: 300px;
}

</style>
